// Enquiry form question components
//
// Each form question should be its own component. Extend /common/EnquiryFormSection to get the correct props structure
// The render() method should return something like this:
// 
// <section id={this.props.id} className={this.props.className}>
//   <header>
//     <h2>Title</h2>
//     <p>Subtitle</p>
//   </header>
//   <div className="enquiry-form-question">
//     >> go wild with react-redux-form fields <<
//   </div>
// </section>

import "./index.scss";

export { FormProgressIcon } from "./formProgressIcon";
export { CountrySelector } from "./countrySelect";
export { Account } from "./accountForm";
export { IndependenceLevelSelect } from "./independenceLevelSelect";
export { TripTypeSelect } from "./tripTypeSelect";
export { BudgetPerPerson } from "./budgetPerPerson";
export { PlanningStageSelect } from "./planningStageSelect";
export { TravelDate } from "./travelDate";
export { ThemesSelect } from "./themesSelect";
export { NotesField } from "./notesField";
export { PhoneNumber } from "./phoneNumber";
export { RecommendedBy } from "./recommendedBy";
export { AgeRanges } from "./ageRanges";
export { CurrencySelect } from "./currencySelect";
export { QSParam, buildFormStateFromQueryString } from "./queryString";
